module.exports = __webpack_public_path__ + "img/electric-ticket.9bc952d0.png";